import { styled } from '@mui/material';
import { Query } from '../../../components/Query';
import { api } from '../../../lib/api';
import { FicheInscriptionTable } from './FicheInscriptionTable';

function FicheInscriptions() {
    return (
        <Query
            queryKey={['formulaire-inscription-entries']}
            apiCall={api.getFicheInscriptionEntries}
        >
            {(data) => (
                <TableContainer>
                    <FicheInscriptionTable ficheInscriptionEntries={data} />
                </TableContainer>
            )}
        </Query>
    );
}

const TableContainer = styled('div')(({ theme }) => ({
    width: '100%',
}));

export { FicheInscriptions };
